import React from "react";
import { observer } from "mobx-react-lite";
import Feedback from "../../../../components/templates/Feedback";
import { IconCheckedLight, skinVars } from "@telefonica/mistica";
import { strings } from "../../../../localization";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { useNavigateCustom } from "../../../../hooks";

const { title, description, button } = strings.pages.signContract.successAlterPassword;
const { anticipateFGTS } = strings.components.buttons;

export const SuccessAlterPassword: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	React.useEffect(() => {
		updatePageView({ name: "Vivo Money FGTS Confirmar Contratação Nova Senha Cadastrada", pagePath: "/fgts/confirmar-contratacao/nova-senha-cadastrada" });
	}, []);

	// navega para assinatura de contrato
	const handleActionFinish = (): void => {
		addAnalyticEvent({ action: "click.button", step: "fgts:confirmar-contratacao:nova-senha-cadastrada", description: button }, { applySanitize: true });
		navigate(-3);
	};

	// volta para tela anterior
	const handleGoBack = (): void => {
		navigate(-3);
	};

	return (
		<Feedback
			heroDataInfoProps={{
				title,
				description,
				icon: <IconCheckedLight size={64} color={skinVars.colors.success} />,
			}}
			buttonProps={{
				onAction: handleActionFinish,
				textButton: button,
				testID: "button-finish-alter-password",
			}}
			screenResponsiveProps={{
				navigationTitle: anticipateFGTS,
				onBack: handleGoBack,
			}}
		/>
	);
});
